import { TabPanel, TabView } from 'primereact/tabview'
import { useState } from 'react'
import PaymentOrders from './PaymentOrders'
import PaymentOrdersRecord from './PaymentOrdersRecord'
import PaymentOrderProvider from '../../components/context/PaymentOrderContext'
const steps = [
    {
        label: 'Items'
    },
    {
        label: 'Retenciones'
    },
    {
        label: 'Forma de pago'
    }
];

function PaymentOrderView() {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <div className='bg-white h-screen p-4 flex flex-column'>
            <h1 className="title font-semibold text-2xl">Pagos</h1>

            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className='paymentTabs flex-grow'>
                <TabPanel header='Nuevo'>
                    <PaymentOrderProvider steps={steps}>
                        <PaymentOrders/>
                    </PaymentOrderProvider>
                </TabPanel>
                {/*<TabPanel header='Historial'>
                    <PaymentOrdersRecord />
                </TabPanel>*/}
            </TabView>
        </div>
    )
}

export default PaymentOrderView
